import { CatalogBuilder } from "../../../commonGroupModuleStructure/catalogBuilder";
import { deleteModule, getModulesPagingData, getModulesTree } from "./apiCall";
import { ModulesKeys } from "./entity";

export const Modules = (props: any) => {

  const listOfModulesColums = [
    {
      field: "DisplayName",
      headerName: "Display Name",
      flex: 1,
      minWidth: 130,
      headerAlign: "left"
    },
    {
      field: "ApplicationName",
      headerName: "Application Name",
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
    {
      field: "Routes",
      headerName: "Routes",
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
  ];

  return (
    <CatalogBuilder
      headerLabel="Modules"
      headerButtonLabel="Add Modules"

      getPagingData={getModulesPagingData}
      pagingAPIKey={ModulesKeys.paging}

      onDelete={deleteModule}
      deletePagingAPIKey={ModulesKeys.delete}

      getTreeData={getModulesTree}
      treeApiKey={ModulesKeys.tree}
      treeViewLabel="Menu > Features > FeatureAccess"

      // pagingColumns={listOfModulesColums}
      onModeClickPath="/modules/details/"
    />
  );
};
